import { useAppSelector } from '../../../Hooks/Hooks';
import { RootState } from '../../../Redux/Store';
import { useContext } from 'react';
import { AppContext } from '../../../Context/AppContext';
import { getMemberDetails } from '../../../Utils/Search';
import { DeviceInfoDataRender } from '../../../Utils/DeviceInfo';
import '../../Shared/LoadCard/ExpandedViewContainer/LoadRateContainer/LoadRateContainer.scss';
import './DeviceInfoTable.scss';

const DeviceInfoTable = () => {
  const { memberData } = useAppSelector((state: RootState) => state.member);
  const { isMobile } = useContext(AppContext);
  const tableKeys = [
    {
      property: 'Platform',
    },
    {
      property: 'Vendor',
    },
    {
      property: 'OS Name',
    },
    {
      property: 'OS Version',
    },
    {
      property: 'Browser Name',
    },
    {
      property: 'Browser Version',
    },
    {
      property: 'Code Version',
    },
  ];
  const tableValues = DeviceInfoDataRender();
  const memberDetails = getMemberDetails(memberData, isMobile);

  let values: any[] = [];
  for (let i = 0; i < tableValues.length; i++) {
    const key = tableValues[i].split(':')[0];
    const value = tableValues[i].split(':')[1];
    if (key !== 'userAgent' || key !== 'appVersion') {
      values.push(value);
    }
  }

  return (
    <div className="DeviceInfoTableContainer">
      <div className="MemberDetails">
        {memberDetails?.map((item, index) => (
          <div key={index}>
            {item.label !== '' && item.value !== '' && (
              <div className="Detail_Item">
                <div className="MemberDetails_Heading">{item.label} :</div>
                <div className="MemberDetails_Details">{item.value}</div>
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="CustomTable">
        <div className="Table_Container Device_Table">
          <div className="Table_Header">
            <span>Details</span>
            <span>Description</span>
          </div>
          <div className="Table_Body">
            {tableKeys?.map((item: any, index: any) => {
              return (
                <div data-testid="table-row" className="Table_Row" key={index}>
                  <span>{item?.property}</span>
                  <span>{values[index] || 'Unknown'}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeviceInfoTable;
